import { API_PATHS, USE_MOCK } from '../config';
import { request } from './client';
import { unwrapApiData } from '../utils/apiResponse';

/** GET /api/projects */
export async function listProjects({ page = 0, size = 20 } = {}) {
  if (USE_MOCK) {
    return { items: [], page: 0, size, total: 0 };
  }
  const query = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  const data = unwrapApiData(await request(`${API_PATHS.projects}?${query.toString()}`));
  return {
    items: data.items || [],
    page: data.page != null ? data.page : page,
    size: data.size != null ? data.size : size,
    total: data.total != null ? data.total : 0,
  };
}

/** GET /api/projects/{projectId} */
export async function getProject(projectId) {
  if (USE_MOCK) {
    throw new Error('演示模式不支持选用历史视频');
  }
  return unwrapApiData(await request(API_PATHS.project(projectId)));
}
